export const defaultLabels = {
    processing: "Processing...",
    pleaseWait: "Please wait while we are Processing.",
    ready: "Ready",
    customerName: "Customer Name",
    customerNumber: "Customer Number",
    amountOfPayment: "Amount of payment",
    payFromPhone: "Pay from my phone",
    payByQrCode: "Pay by scanning this QR Code",
    copyAndShare: "Copy and share link for payment",
    urlCopied: "URL copied to clipboard",
    errorCopyingUrl: "Error copying URL: ",
    refIdNotGenerated: "RefId not generated yet",
    payForGroupMember: "Pay For a Group Member",
    paymentType: "Payment Type",
    amountOverdue: "Amount Overdue",
    amountDue: "Amount Due",
    proceedToPay: "Proceed to pay",
    paymentFor: "Payment For",
    dueDate: "Due Date",
    wantToPay: "I Want To Pay (Rs)",
    instalmentWarning: "Instalment can be paid 3 days prior to due date.",
    lessAmountWarning: "You are paying less than the amount due.",
    yourGroup: "Your group",
    health: "Health",
    activeMembers: "Active Members",
    overdueMembers: "Overdue Members",
    overdue: "Overdue",
    mobileNumber: "Mobile Number",
    outstandingBalance: "Outstanding Balance",
    instalmentNumber: "Instalment Number",
    nextDueDate: "Next due date",
    payDue: "Pay Due",
    payNextInstallment: "Pay next installment",
    yourLoan: "Your loan",
    welcome: "Welcome",
    date: "Date",
    helplineTitle: "Helpline",
    customerHelpline: "Svasti Customer Helpline",
    helplineNumber: "9769616817",
    branchTitle: "Branch",
    branch: "Branch",
    branchManager: "Branch Manager",
    contactNumber: "Contact Number",
    croTitle: "CRO",
    croName: "CRO Name",
    contact: "Contact",
    home: "Home",
    notifications: "Notifications",
    logout: "Logout",
    pleaseWaitForPayment: "Please wait while the payment is being processed.",
    thankYouMessage: "Thank you! Your payment has been successfully processed.",
    payerAmount: "Payer Amount",
    bankRrn: "Bank RRN",
    transactionDate: "Transaction Date",
    paymentFailure: "Your payment has failed. Please try again.",
    PayForAWholeGroup: "Pay For a Whole Group",
    GroupName: "Group Name",
    GroupId: "Group Number",
    Soa: "Statement",
    loanAmount: "Loan Amount",
    disbursementDate: "Disbursement Date",
    balanceOutstanding: "Balance Outstanding",
    firstCollectionDate: "First Collection Date",
    transactionsHeader: "Transactions",
    principal: "Principal",
    interest: "Interest",
    total: "Total",
    pos: "POS",
    statementOfAccount:"Statement Of Account",
    proceedToPayForSelected:"Proceed To Pay For Selected Member"
};


const apiUrl = "https://microservices.svasti.in/CustomerFacingService/LabelsByCustomerLanguage";

async function fetchLabels() {
    const storedLanguage = sessionStorage.getItem("CommunicationLanguage");
    const preferredLanguage = JSON.parse(storedLanguage) || "English";

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'X-API-KEY': process.env.REACT_APP_API_KEY,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data: [
                    { "language": preferredLanguage }
                ]
            })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return mapTranslations(defaultLabels, data);
    } catch (error) {
        return defaultLabels; // Return default labels in case of error
    }
}

function mapTranslations(defaultLabels, translations) {
    const translatedLabels = { ...defaultLabels };

    translations?.data?.forEach(item => {
        const labelKey = item.Label;
        const labelValue = item.Value;

        if (translatedLabels[labelKey] !== undefined) {
            translatedLabels[labelKey] = labelValue;
        }
    });
    return translatedLabels;
}

export { fetchLabels };